/**
 *  @file src/utils/JWTToken.js
 *  @description Support for JWTToken.
 */

export default class JWTToken {

    get token() { return this._token; }
    get decoded() { return this._decoded; }
    get userId() { return this._decoded && this._decoded.userId ? this._decoded.userId : null }

    /**
     *  @constructor
     *  @param {string} token - JWTToken.
     */
    constructor(token) {
        if (!token) {
            throw new Error('Invalid JWT token given in constructor');
        }
        this._token = token;
        this._decoded = null;
        this.__init();
    }

    /**
     * @function __init
     * @description Decrypt the JWT token
     */
    __init() {
        if (this._token) {

            // Split the token into its parts
            const parts = this._token.split('.');

            if (parts.length !== 3) {
                throw new Error('Invalid JWT token format');
            }

            // Decode the payload (second part)
            const payload = parts[1];
            this._decoded = JSON.parse(atob(payload));
        }
    }
}
